/* unplugin-vue-components disabled */import { render } from "./test_modal.vue?vue&type=template&id=3082588f"
import script from "./test_modal.vue?vue&type=script&lang=js"
export * from "./test_modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__